import './scss/index.scss';
import { CookiePolicy } from './CookiesPolicy';

export default props => new CookiePolicy({
	...props,
});


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/CookiesPolicy4/index.js